import React from 'react'
import { observer } from 'mobx-react'
import cn from 'classnames'

import styles from './mask.scss'

interface IProps {
  className?: string
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
}

const Mask = ({ className, onClick }: IProps) => {
  return (
    <div
      data-cy="mask"
      className={cn(styles.mask, className)}
      onClick={onClick}
    />
  )
}

export default observer(Mask)
